export default {
  allDestinations: [],
  offer: { cities: [] },
  selectedCode: '',
  prices: [],
  hotels: [],
  moreDestinationsBanners: {
    logged: null,
    nonLogged: null
  },
  modalSmartLinkImages: null,
  filterApply: {
    code: '',
    type: ''
  },
  datesFromLanding: {
    startDate: '',
    endDate: ''
  },
  formattedLocation: []
}
